module.exports = __webpack_public_path__ + "img/9.2ace0b59.jpg";